import { IMember } from "../../interfaces/iMember";
import { INonprofit } from "../../interfaces/iNonprofit";
import { IActivity } from "../../interfaces/companyProfile/iActivity";

export class Activity implements IActivity {
    role: string;
    member: IMember;
    datetime: string;
    nonprofit: INonprofit;
    involvedMembers: IMember[];
    key: string;

    constructor(activity: IActivity = {} as IActivity) {
        this.role = activity.role;
        this.member = activity.member;
        this.datetime = activity.datetime;
        this.nonprofit = activity.nonprofit;
        this.involvedMembers = activity.involvedMembers;
        this.key = activity.key;
    }
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/companyProfile/activity.ts